import "./PrecisionPortfolio.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import ExploreTheLibrary from "./sections/ExploreTheLibrary";
import VocesDelVecindario from "./sections/VocesDelVecindario";
import Footer from "@/reusable_sections/Footer";
export default function PrecisionPortfolioPage() {
  return <div>
      <VoltMainHeader />
      <ExploreTheLibrary />
      <VocesDelVecindario />
      <Footer />
    </div>;
}